<div>
    <mat-form-field>
        <mat-select [(value)]="currentComfortTypeId">
          <mat-option class="select-without-checkbox" *ngFor="let comfortType of comfortTypes" [value]="comfortType.id">
            {{comfortType.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
</div>
<div *ngFor="let grid of gridDataList">
    <app-grid-list *ngIf="grid.comfortTypeId===currentComfortTypeId" [data]="grid.grid" [isEditable]="isEditable" [isShortVersionNeeded]="true"></app-grid-list>
</div>